export const isOrgType = (org, type) =>
  (org?.orgType ?? "").toLowerCase() === type.toLowerCase();
